import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';
import Identifiers from './reports/Identifiers'
import Conversation from './reports/Conversation'
import FinalMessage from './reports/FinalMessage'
import Title from './reports/Title'
import Footer from "./reports/Footer";
import Header from './reports/Header'

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 80,
    paddingLeft: 60,
    paddingRight: 60,
    paddingBottom: 40,
    lineHeight: 1.5,
    flexDirection: 'column',
  }
});

export default function handleDescargaPDF(language, user, messages, date) {

  let MyDocument = () => (
    <Document title="Conversación con el asistente virtual" author="Defensor del Pueblo" language="es">
      <Page size="A4" style={styles.page}>
        <Header />
        <Title title='Conversación con el asistente virtual' />
        <Identifiers identifier={user} date={date}/>
        <Conversation items={messages} />
        <FinalMessage wrap={false} />
        <Footer />
      </Page>
    </Document>
  );
  return MyDocument
}